import React, { useState, useRef, useEffect } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { gsap } from 'gsap';
import './UpcomingListWidget/UpcomingListWidget.scss';
import { useCourtCaseDetails } from './useCaseCourtDetails';
import { useNavigate } from 'react-router-dom';
import { WrittenFormat } from '../components/WrittenFormat'
import { formatPartyNames } from './TruncateParties';
import draftToHtml from 'draftjs-to-html';
import doc from '.././assets/images/note-icon.png'
import cal from '.././assets/images/cal-icon.png'
import adv from '.././assets/images/adv-icon.png'
import ref from '.././assets/images/ref-icon.png'
import desc from '.././assets/images/description-icon.png'
import load from '.././assets/images/load-icon.png'
import comp from '.././assets/images/comp-icon.png'
import err from '.././assets/images/err-icon.png'
import pend from '.././assets/images/cross-icon.png'
import bar from '.././assets/images/bar-icon.png'


const TASK_ICONS = {
  REFERENCE: (
    <img
      src={ref}
      alt="Reference"
      className="icon-image"
      width="16"
      height="16"
    />
  ),
  DOCUMENT: (
    <img
      src={doc}
      alt="Document"
      className="icon-image"
      width="16"
      height="16"
    />
  ),
  DESCRIPTION: (
    <img
      src={desc}
      alt="Description"
      className="icon-image"
      width="16"
      height="16"
    />
  ),
  CALENDAR: (
    <img
      src={cal}
      alt="Calendar"
      className="icon-image"
      width="16"
      height="16"
    />
  ),
  LOADING: (
    <img
      src={load}
      alt="Loading"
      className="icon-image rotating"
      width="16"
      height="16"
    />
  ),
  SCALE: (
    <img
      src={bar}
      alt="Scale"
      className="icon-image"
      width="16"
      height="16"
    />
  ),
  COURT: (
    <img
      src={bar}
      alt="Court"
      className="icon-image"
      width="16"
      height="16"
    />
  ),
  ADVOCATE: (
    <img
      src={adv}
      alt="Advocate"
      className="icon-image"
      width="16"
      height="16"
    />
  ),
  COMPLETED: (
    <img
      src={comp}
      alt="Completed"
      className="icon-image"
      width="16"
      height="16"
    />
  ),
  PENDING: (
    <img
      src={pend}
      alt="Pending"
      className="icon-image"
      width="16"
      height="16"
    />
  ),
  ERROR: (
    <img
      src={err}
      alt="Error"
      className="icon-image"
      width="16"
      height="16"
    />
  )
};

// Small wrapper component to use the hook for each task item
export const TaskItemWithCaseDetails = ({ item, formatDate, handleTooltipEnter, handleTooltipLeave }) => {
  const navigate = useNavigate()
  const { caseData, loading, error } = useCourtCaseDetails(item.courtRef);

  // ...existing code...

  return (
    <>
      <span className="card-emoji"></span>
      <div className="card-details">
        <div className="card-title">
          {item.taskName}
          <span className={`status-chip ${item.isCompleted ? 'completed' : 'pending'}`}>
            {item.isCompleted ? (
              <>
                {TASK_ICONS.COMPLETED} Done
              </>
            ) : (
              <>
                {TASK_ICONS.PENDING} Pending
              </>
            )}
          </span>
        </div>
        <div
          className="card-sub ref-with-tooltip"
          onClick={(e) => { e.stopPropagation(); navigate(`/home/cases/casedetails/${item.courtRef}`); }}
          onMouseEnter={
            handleTooltipEnter && caseData?.case?.parties
              ? (e) => handleTooltipEnter(e, caseData.case.parties)
              : undefined
          }
          onMouseLeave={handleTooltipLeave}
        >
          {TASK_ICONS.REFERENCE} Ref: {formatPartyNames(caseData?.case?.parties)}
        </div>

        {caseData && caseData.case.caseTypeAndNumber && (
          <div className="card-sub">
            {TASK_ICONS.DOCUMENT} Case Type & No: {caseData.case.caseTypeAndNumber}
          </div>
        )}

        {item.description && (
          <div className="card-sub">
            {TASK_ICONS.DESCRIPTION} Description: {item.description ? (
                (() => {
                  let html = '';
                  try {
                    const raw = typeof item.description === 'string' ? JSON.parse(item.description) : item.description;
                    if (raw && raw.blocks) {
                      html = draftToHtml(raw);
                    } else {
                      html = item.description;
                    }
                  } catch (e) {
                    html = item.description;
                  }
                  // Fix anchor tags to always use absolute URLs
                  let fixedHtml = html.replace(/<a ([^>]*href=["'])(?!https?:\/\/)([^"'>]+)(["'][^>]*)>/gi, '<a $1https://$2$3>');
                  
                  fixedHtml = fixedHtml.replace(/<a /gi, '<a target="_blank" rel="noopener noreferrer" ');
                  return <div dangerouslySetInnerHTML={{ __html: fixedHtml }} />;
                })()
              ) : (
                <p>No description provided</p>
              )}
          </div>
        )}

        {item.dueDate && (
          <div className="card-sub">
            {TASK_ICONS.CALENDAR} Due: {formatDate(item.dueDate)}
          </div>
        )}

        {/* Display loading state */}
        {loading && (
          <div className="card-sub">
            {TASK_ICONS.LOADING} Loading case details...
          </div>
        )}

        {/* Display error state */}
        {/* {error && (
          <div className="card-sub" style={{ color: 'red' }}>
            {TASK_ICONS.ERROR} Error loading case details
          </div>
        )} */}

        {/* Display fetched case data */}
        {caseData && (
          <>
            {/* {caseData.case.caseStatus?.['Case Stage'] && (
              <div className="card-sub">
                {TASK_ICONS.SCALE} Stage: {caseData.case.caseStatus['Case Stage']}
              </div>
            )}
            
            {caseData.case.caseStatus?.['Court Number and Judge'] && (
              <div className="card-sub">
                {TASK_ICONS.COURT} Judge: {caseData.case.caseStatus['Court Number and Judge']}
              </div>
            )} */}

            {caseData.case.advocates && (
              <div className="card-sub">
                {TASK_ICONS.ADVOCATE} Advocate: {caseData.case.advocates}
              </div>
            )}

            {caseData.case.caseDetails?.['Filing Date'] && (
              <div className="card-sub">
                {TASK_ICONS.CALENDAR} Filed: {caseData.case.caseDetails['Filing Date']}
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};